import React from 'react';
import { Helmet } from 'react-helmet';
import * as snippet from '@segment/snippet';
import { getRandomNonce } from './utilities/crypto';
import { isDevelopment } from './utilities/isDevelopment';
import { repairSmithFieldOps } from './utilities/getRepairSmithFieldOps';

const renderSegmentSnippet = () => {
  const { ANALYTICS_WRITE_KEY } = repairSmithFieldOps;
  const opts = {
    apiKey: ANALYTICS_WRITE_KEY,
    page: false, // Set this to `false` if you want to manually fire `analytics.page()` from within your pages.
  };
  if (isDevelopment()) {
    return snippet.max(opts);
  }

  return snippet.min(opts);
};

type DocumentProps = {
  children: React.ReactNode;
};

const Document = ({ children }: DocumentProps) => {
  const cspNonce = getRandomNonce();
  return (
    <>
      <Helmet>
        <script nonce={cspNonce}>{renderSegmentSnippet()}</script>
      </Helmet>
      {children}
    </>
  );
};

export default Document;
